import React from 'react';
import { GameProvider } from './context/GameContext';
import { ChromiaProvider } from './context/ChromiaContext';
import StartMenu from './components/StartMenu';
import GameArea from './components/GameArea';

function App() {
    return (
        <GameProvider>
            <ChromiaProvider>
                <div className="app">
                    <StartMenu />
                    <GameArea />
                </div>
            </ChromiaProvider>
        </GameProvider>
    );
}

export default App;


